import React, { useEffect, useRef, useState } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import Swal from "sweetalert2";
import utils from '../../utils/generalFunctions';
import Loading from "../../components/Loading.js";
import { toast } from 'react-toastify';
import moment from "moment";
import EstudianteFilter from "../../components/Filters/EstudianteFilter.js";
import JornadaAnioNivelCurso from "../../components/Filters/JornadaAnioNivelCurso.js";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from '@fullcalendar/core/locales/es';
import 'moment/locale/es';
import agendaService from "../../services/agendaService.js";
import AgendaForm from "../../components/Forms/AgendaForm.js";
import DocumentItem from "../../components/documentItem.js";

moment.locale('es');

const Agenda = () => {

    const initData ={
        schoolYearId: "0",
        journeyId:"0",
        periodId:"",
        educationLevelId: "0",
        gradeId:"0",
        courseId:"0",
        studentId:"0",
        startDate: moment().startOf('month').format("yyyy-MM-DD"),
        endDate:moment().endOf('month').format("yyyy-MM-DD")
    };
    const rangoActualRef = useRef({
        startDate: moment().startOf('month').format("yyyy-MM-DD"),
        endDate: moment().endOf('month').format("yyyy-MM-DD")
      });

    const [formData, setFormData] = useState(initData);
    const [periodos, setPeriodosList] = useState([]);
    const [datosBusqueda, setDatosBusqueda] = useState([]);
    const [agenda, setAgenda] = useState([]);
    const filteReference = useRef(null);
    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
    const [selectedEvento, setSelectedEvento] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [modalOpen, setModalOpen] = useState(false); // Estado para manejar la visibilidad del modal
    const [BtnVer, setBtnVer] = useState('');
    const colores = [
        '#3788d8', // Azul
        '#f79635', // Naranja
        '#d83738', // Rojo
        '#d83788', // Rosado
        '#38d837', // Verde
        '#8737d8'  // Morado
      ];
    const eventos = [...agenda].map((row) => {
        
        return {
            id: row.agendaId,
            title: row.title,
            description:row.description,
            start: row.startDate,
            end:row.endDate,
            journey:row.journeyName,
            year:row.schoolYearName,
            educationLevel:row.educationLevelName,
            grade:row.gradeName,
            course:row.courseName,
            student:row.studentName,
            documents:row.documents,
            backgroundColor: row.colorAleatorio, // Color del fondo
            borderColor: row.colorAleatorio,     // Color del borde
            textColor: '#ffffff'             // (opcional) Color del texto, si quieres forzar que sea legible
        };
    });

    const deleteEventoById = async(eventoId) => {
        Swal.fire({
            title: '¿Está seguro que desea eliminar este evento?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
          }).then(async(result) => {
            if (result.isConfirmed) {
                try{
                    await agendaService.deleteEventoAgendaById(eventoId);  
                    Swal.fire(
                        '¡Felicidades!',
                        'Evento eliminado exitosamente!',
                        'success'
                    );
                    BuscarAgenda();
                }catch(error){
                    Swal.fire(
                        "Ha ocurrido un error",
                        "Por favor intente más tarde",
                        "error"
                    );
                }
            }
        })
    }

    const BuscarAgenda = async (e, hideLoading) =>{
          if(e) e.preventDefault();
          if(!hideLoading) setShowLoading(true);
          setAgenda([]);
            const requiredFields = [];//['schoolYearId', 'journeyId','educationLevelId','gradeId','courseId'];
            for (let field of requiredFields) {
                if (!formData[field] || formData[field]==='0') {
                    toast.error("Por favor, completa todos los campos obligatorios.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                    return;
                }
            }
            setDatosBusqueda([]);
            try {
               const copyData = utils.copy(formData);
               const cursos = filteReference?.current?.getCursos();
               if (cursos.length > 0) {
                    copyData.gradeId = cursos.find(c => String(c.courseId) === String(copyData.courseId))?.gradeId;
               }
               copyData.periodName = periodos.find(p=>String(p.academicPeriodId)===String(copyData.periodId))?.periodName??"";
               const years = filteReference.current?.getSchoolYears();
               if(years){
                    copyData.year = years.find(p=>String(p.schoolYearId)===String(copyData.schoolYearId))?.year??"";
               }
               const journeys = filteReference.current?.getJourneys();
               if(journeys){
                    copyData.journey = journeys.find(p=>String(p.journeyId)===String(copyData.journeyId))?.name??"";
               }
    
               const courses = filteReference.current?.getCursos();
               if(courses){
                    copyData.course = courses.find(p=>String(p.courseId)===copyData.courseId)?.name??"";
               }
    
               const educationLevels = filteReference?.current?.getEducationLeves();
               if (educationLevels.length > 0) {
                    copyData.evaluationTypeId = educationLevels.find((c) => String(c.educationLevelId) === String(copyData.educationLevelId))?.evaluationTypeId;
               }

              setDatosBusqueda(copyData);
              const data = await agendaService.getAgenda(
                copyData.schoolYearId, 
                copyData.journeyId,
                copyData.educationLevelId, 
                copyData.gradeId,
                copyData.courseId, 
                copyData.studentId, 
                rangoActualRef.current.startDate, 
                rangoActualRef.current.endDate); // Obtenemos los estudiantes de tu sistema
                
              if(data && data.length>0){
                
                const dataTransform= data.map(obj =>{
                                const colorAleatorio = colores[Math.floor(Math.random() * colores.length)];
                                obj.colorAleatorio = colorAleatorio; // Color del fondo
                                obj.borderColor= colorAleatorio;     // Color del borde
                                return obj;
                });
                setAgenda(dataTransform);
              }else{
                setAgenda([]); 
              }
            } catch (error) {
              console.error("Error al obtener horario:", error);
            }
            if(!hideLoading) setShowSearch(true);
            if(!hideLoading) setShowLoading(false);// Cambia el estado a false una vez que los datos se carguen
    }

    const handleFilterChange = (newFilters) => {
        // Actualiza el estado de filters con los nuevos valores
        setFormData(prev => ({
            ...prev,
            ...newFilters
        }));
    };

    const handleDatesSet = (info) => {
        const startDate = info.startStr;
        const endDate = info.endStr;
    
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
    
        console.log('Calculado: ', start, end);
    
        // Aquí comparamos con el rango que tenemos guardado en el ref
        if (
          start !== rangoActualRef.current.startDate ||
          end !== rangoActualRef.current.endDate
        ) {
          console.log('Cambiando el rango de fechas...');
          
          // Actualizamos el ref SIN disparar render
          rangoActualRef.current = {
            startDate: start,
            endDate: end
          };
    
          // Ahora sí actualizamos el estado si quieres
          setFormData({
            startDate: start,
            endDate: end
          });
    
          // Y aquí llamas la función que necesites solo cuando cambien las fechas
          BuscarAgenda(null, true);
        }
    };

    const studentInfoChange = (student) => {
        if(student){
        filteReference?.current?.setFormValues({ 
            journeyId: student.journeyId,
            schoolYearId: student.schoolYearId,
            educationLevelId: student.educationLevelId,
            courseId: student.courseId});
        }else{
            filteReference?.current?.setFormValues({ 
                journeyId: '0',
                schoolYearId: '0',
                educationLevelId: '0',
                courseId: '0'});
        }
    };

    const openModal = () => {
        setShowSearch(true);
        setSelectedEvento(null);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleEventClick = (info) => {
        info.jsEvent.preventDefault();
        const eventId = Number(info.event._def.publicId??'0');
        // Muestra un alert con el título del evento
        setSelectedEvento(eventId);
        setModalOpen(true);
      };

    useEffect(() => {
        BuscarAgenda(null);
    }, []);

        return (
            <>
                 <div className="card p-3">
                    <div className="card-header">
                        <h2 className="">Gestión de agenda escolar</h2>
                        <h5 className="card-subtitle text-muted">Esta es la vista para gestionar la agenda estudiantil.</h5>
                </div>
              <div className="card-body">
                    <form className="row g-2 align-items-center mb-3">
                        <div className="col-md-4">
                             <EstudianteFilter 
                                callback={handleFilterChange} 
                                callbackStudentInfo={studentInfoChange}
                                properties={
                                    {
                                        className: 'w-100',
                                    }
                                }
                                />
                          </div>
                          <div className="col-md-7">
                                <JornadaAnioNivelCurso
                                        callback={handleFilterChange}
                                        ref={filteReference}
                                        properties={
                                            {
                                                className: '',
                                                id:'formAgenda',
                                                filtro:true
                                            }
                                        }
                                    />
                            </div>
                            <div className="col-md-1  d-flex align-items-end">
                              <button
                                    onClick={BuscarAgenda}
                                    className="btn btn-primary mt-3 w-100"
                                >
                                    Buscar
                                </button>
                            </div>
                        </form>
                </div>
            </div>
           
            <div className="card p-3 margin-top-12">
                <div className="row">
                    <div className="text-end mb-3">
                        <button className="btn btn-primary" onClick={openModal}>Crear Evento <i className="fa-solid fa-circle-plus"></i></button>
                    </div>
            
                {showLoading && <Loading />}
        
                {showSearch && (
                <>
                    {!showLoading && (
                    <>
                            
                        {/* Calendario */}
                        <div className="col-lg-7">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                <FullCalendar
                                    datesSet={handleDatesSet}
                                    timeZone={'local'}
                                    locales={[ esLocale ]}
                                    plugins={[dayGridPlugin, interactionPlugin]}
                                    initialView="dayGridMonth"
                                    events={eventos}
                                    eventClick={handleEventClick}
                                    locale="es"
                                    headerToolbar={{
                                    left: 'prev,next today',
                                    center: 'title',
                                    right: 'dayGridMonth,dayGridWeek',
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
  <div className="card shadow border-0 rounded-4">
    {/* Encabezado */}
    <div className="card-header bg-primary text-white rounded-top-4 py-3">
    <h4 className="card-title mb-0 d-flex align-items-center text-white">
  <i className="bi bi-calendar-event-fill me-2 fs-3 text-white"></i>
  Agenda
</h4>

    </div>

    {/* Contenido */}
    <div 
      className="card-body p-4" 
      style={{ maxHeight: '600px', overflowY: 'auto' }}
    >
      {eventos.length > 0 ? (
        eventos.map((evento) => (
          <div 
            key={evento.id} 
            className="d-flex justify-content-between align-items-start mb-4 p-3 bg-light rounded-3 shadow-sm"
          >
            <div className="flex-grow-1 pe-3">
              {/* Título del evento */}
              <h5 className="fw-bold mb-2 text-dark">{evento.title}</h5>

              {/* Descripción */}
              <p className="text-secondary mb-3 fs-6">
                <div dangerouslySetInnerHTML={{ __html: evento.description }} />
              </p>

              <table className='w-auto ml-20 mt-20'>
                  {evento.documents && evento.documents.length> 0 && evento.documents?.map((doc) => (
                      <DocumentItem 
                          document={doc}
                          ReadOnly={true}
                          EnableDelete={true}
                          deleteDocument={null}
                      />
                  ))}
              </table>

              {/* Fechas */}
              <div className="text-muted mb-2 fs-6">
                📅 {moment(evento.start).format('D MMM YYYY')} - {moment(evento.end).format('D MMM YYYY')}
              </div>

              {/* Detalles adicionales */}
              {evento.journey && (
                <div className="text-muted mb-2 fs-6">🌤️ {evento.journey}</div>
              )}
              {evento.educationLevel && (
                <div className="text-muted mb-2 fs-6">🏫 {evento.educationLevel}</div>
              )}
              {evento.course && (
                <div className="text-muted mb-2 fs-6">🧑🏻‍🏫 {evento.course}</div>
              )}
              {evento.student && (
                <div className="text-muted mb-2 fs-6">🧑🏻‍🎓 {evento.student}</div>
              )}
            </div>

            {/* Botón eliminar */}
            <button className="btn btn-danger" variant="danger" size="sm" onClick={() => deleteEventoById(evento.id) }>
                                            <i className="fas fa-trash"></i>
                                            </button>
          </div>
        ))
      ) : (
        <p className="text-muted text-center fs-5 mb-0">No hay eventos programados.</p>
      )}
    </div>
  </div>
</div>

                        
                            
                    </>
                    )}
                </>
                )}
                </div>        
            </div> 
            <MDBModal show={modalOpen} setShow={setModalOpen} tabIndex='-1'>
                <MDBModalDialog className="modal-lg">
                <MDBModalContent>
                    <MDBModalHeader>
                    <MDBModalTitle>Evento</MDBModalTitle>
                    <button className='btn-close' color='none' onClick={closeModal}></button>
                    </MDBModalHeader>
                    <MDBModalBody>
                    <div className=''>
                        {selectedEvento && (
                            <AgendaForm
                                key={Date.now()}
                                agendaId={selectedEvento}
                                onClose={() => {
                                    setModalOpen(false); 
                                    BuscarAgenda(null,true);
                                }}
                                ReadOnly={BtnVer}
                            />
                        )}

                        {!selectedEvento && (
                            <AgendaForm
                                key={Date.now()}
                                agendaId={0}
                                onClose={() => {
                                    setModalOpen(false); 
                                    BuscarAgenda(null,true);
                                }}
                                ReadOnly={false}
                            />
                        )}
                    </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                    <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                    </MDBModalFooter>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>             
            </>
        );
};

export default Agenda;